import Dexie, { type EntityTable } from "dexie";
import type { LocalDraftRecord } from "./schema";

class DraftDatabase extends Dexie {
  dailyLogDrafts!: EntityTable<LocalDraftRecord, "draft_id">;

  constructor() {
    super("DraftDatabase_v3");
    this.version(1).stores({
      dailyLogDrafts: "draft_id, project_id, updated_at",
    });
  }
}

export const draftDB = new DraftDatabase();

// 과거 이름의 DB가 디바이스에 남아 있을 수 있어 한 번 정리한다.
// Why: 이전에 같은 이름 DraftDatabase 의 versionchange upgrade(clear) 단계에서
// Chrome IDB UnknownError 가 발생해 connection 이 닫히는 사례가 있었다 (Sentry).
for (const name of ["DraftDatabase", "DraftDatabase_v2"]) {
  Dexie.delete(name).catch(() => {});
}
